import {
  AfterViewInit,
  Component,
  OnInit, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {ToTrinhService} from '../../../../service/totrinh/service-totrinh';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {YeuCauXuLyService} from '../../../../service/yeucau/service-yeucauxuly';
import {MeetingService} from '../../../../service/info/service-meeting';
import {ThongBaoService} from '../../../../service/info/service-thongbao';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {environment} from '../../../../../environments/environment';
import {BaseChartDirective, Color} from 'ng2-charts';
import {MeetingXuLyService} from '../../../../service/info/service-meetingxuly';
import {NavItemService} from '../../../../service/staff/service-navitem';

@Component({
  selector: 'egov-tonghoplist-giaiquyetsuvu',
  templateUrl: './tonghoplist.component.html',
  encapsulation: ViewEncapsulation.None
})
export class GiaiQuyetSuVuTongHopListComponent implements OnInit, AfterViewInit {
  public totalToTrinhXuLy: number =0;
  public totalToTrinhNhan: number =0;
  public totalToTrinhDangSoan: number =0;
  public totalYeuCauGui: number =0;
  public totalYeuCauNhan: number =0;
  public totalYeuCauDangSoan: number =0;
  public totalCuocHop:  number=0;
  public totalCuocHopChuaXem:  number=0;
  public totalThongBao: number =0;
  public totalThongBaoChuaXem: number =0;
  public totalTCChuaXuLy: number=0;
  public totalTCDangXuLy: number=0;
  public totalTCHoanThanh: number=0;
  public totalTCChuaXem: number=0;
  public ty: string = '';
  public totalYCChuaXuLy: number=0;
  public totalYCDangXuLy: number=0;
  public totalYCHoanThanh: number=0;
  public totalYCChuaXem: number=0;
  public language = language;
  public permissionToTrinh: boolean = false;
  public permissionYeuCau: boolean = false;
  public permissionDocThongBao: boolean = false;
  public permissionThongBaoPrivate: boolean = false;
  public permissionCuocHop: boolean = false;

  public status: number[] =[
    environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  constructor(
    public toTrinhService: ToTrinhService,
    public toTrinhXuLyService: ToTrinhXuLyService,
    public yeuCauService: YeuCauService,
    public yeuCauXuLyService: YeuCauXuLyService,
    public meetingService: MeetingXuLyService,
    public thongBaoService: ThongBaoService,
    public navItemService: NavItemService
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.loadTotal();
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0022', true).subscribe(
      x => { this.permissionToTrinh = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0019', true).subscribe(
      x => { this.permissionThongBaoPrivate = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0025,0026', true).subscribe(
      x => { this.permissionYeuCau = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,'0020,0021', true).subscribe(
      x => { this.permissionDocThongBao = x>0 ? true: false;}
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001,0079", true).subscribe(
      x => { this.permissionCuocHop = x> 0? true: false;
      }
    );

  }

  public loadTotal()
  {
    this.toTrinhService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhNhan = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, 0, '','').subscribe(recordCount => this.totalTCChuaXem = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCChuaXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCDangXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalTCHoanThanh = recordCount);
    this.toTrinhService.getCountByKeyword('', environment.soanthao.toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalToTrinhDangSoan = recordCount);
    this.yeuCauService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauGui = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1,'','').subscribe(recordCount => this.totalYeuCauNhan = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCChuaXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.dangxuly.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCDangXuLy = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.hoanthanh.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYCHoanThanh = recordCount);
    this.yeuCauXuLyService.getCountByKeyword('', environment.chuaxuly.toString(), Sessioncommand.staffId, 0, '','').subscribe(recordCount => this.totalYCChuaXem = recordCount);
    this.yeuCauService.getCountByKeyword('',  environment.soanthao.toString(), Sessioncommand.staffId, -1, '','').subscribe(recordCount => this.totalYeuCauDangSoan = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, -1).subscribe(recordCount => this.totalCuocHop = recordCount);
    this.meetingService.getCountByKeyword('', this.status.join().toString(), Sessioncommand.staffId, 0).subscribe(recordCount => this.totalCuocHopChuaXem = recordCount);

    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => {
        this.thongBaoService.findAllByCountAlert(Sessioncommand.staffId, (x > 0 ? -1 : Sessioncommand.staffId)).subscribe(recordCount => this.totalThongBaoChuaXem = recordCount);
        this.thongBaoService.getCountByKeyword('', (x > 0 ? -1 : Sessioncommand.staffId), -1).subscribe(recordCount => this.totalThongBao = recordCount);

      }
    );

  }

}

